export default __webpack_public_path__ + "static/N0309-5787390d24102e6162abbb0fd3725cb7.png";